import { Base2Presenter } from "core/presenter";

import { AccountRepository } from "core/repository";

import PasswordRecoveryConstraint from "core/constraint/password-recovery.constraint";
import validate from "validate.js";

export default class PasswordRecoveryPresenter extends Base2Presenter {
  initialState() {
    return {
      loading: false,
      error: null,
      form: {
        submitted: false,
        fields: {
          password: "",
          confirmPassword: ""
        },
        errors: {
          password: "",
          confirmPassword: ""
        }
      }
    };
  }

  async onFormSubmit(password, confirmPassword) {
    const params = {
      password: password,
      confirmPassword: confirmPassword
    };
    const isValid = this.onValidate(params);

    if (!isValid) {
      return;
    }

    this.enqueue({ loading: true });

    const response = await AccountRepository.changePassword({
      reset_password_token: this.routeParams.token,
      password
    });

    if (response.success) {
      this.sendNotification({
        type: "success",
        content: "Senha atualizada com sucesso!"
      });
      this.redirectToLogin();
    } else {
      this.sendNotification({
        type: "error",
        title: "Ooopss...",
        content:
          "Não foi possível atualizar sua senha no momento.\nTente novamente mais tarde ou entre em contato com o suporte."
      });
    }
    this.enqueue({ loading: false });
  }

  onValidate(params) {
    const constraint = PasswordRecoveryConstraint.passwordRecovery;

    const validation = validate(params, constraint, { fullMessages: false });

    if (!!validation) {
      const errors = Object.entries(validation)
        .map(([field, error]) => ({ field, content: error[0] }))
        .reduce(
          (vmErrors, error) => ({ [error.field]: error.content, ...vmErrors }),
          {}
        );

      this.enqueue(vm => ({ form: { ...vm.form, errors } }));

      return false;
    } else {
      this.enqueue(vm => ({ form: { ...vm.form, errors: {} } }));

      return true;
    }
  }

  redirectToLogin() {
    this.navigateTo("app.login");
  }
}



// WEBPACK FOOTER //
// ./src/components/app/password-recovery/presenter.js